<input
  [attr.aria-describedby]="id + '-formly-validation-error'"
  [attr.aria-invalid]="showError"
  [class.is-invalid]="showError"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [max]="props.max"
  [min]="props.min"
  [step]="props.step"
  class="form-control"
  astrobinNoScroll
  type="number"
/>
